import { render, staticRenderFns } from "./ProfitAndLaba.vue?vue&type=template&id=01e423cc"
import script from "./ProfitAndLaba.vue?vue&type=script&lang=js"
export * from "./ProfitAndLaba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports